import React from 'react'
import isEqual from 'lodash/isEqual'
import Box from 'transfix-ui/core/Box'
import { brandColors } from 'transfix-ui/theme/colors'
import { Button } from 'transfix-ui'
import { defaultQuoteFilters } from '../../constants/quoteFilters'
import { TQuoteFilters } from '../../types'
import { getAppliedFilterNames } from '../../utils/getAppliedFilterNames'

export interface IAppliedQuoteFiltersProps {
  quotesFilters: TQuoteFilters
  onClearFilters: () => void
}

export const AppliedQuoteFilters = ({
  onClearFilters,
  quotesFilters,
}: IAppliedQuoteFiltersProps) => {
  if (isEqual(quotesFilters, defaultQuoteFilters)) {
    return null
  }
  const appliedFilters = getAppliedFilterNames(quotesFilters)
  return (
    <Box color={brandColors.gray3} ml={1}>
      <span>{appliedFilters}</span>{' '}
      {appliedFilters.length > 0 && (
        <Button color='tertiary' onClick={onClearFilters}>
          Clear All
        </Button>
      )}
    </Box>
  )
}
